import './publicPath';
import './Polyfill';
import React from 'react';
// import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';


const reactRender = window.wp.element.render;

const meta = document.createElement('meta');
meta.name = "viewport";
meta.content = "width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=no";


document.head.appendChild( meta);

reactRender(<App />, document.getElementById('js-interactive'));




window.onbeforeunload = function () {
    window.scrollTo(0, 0);
}


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
